import { render, staticRenderFns } from "./trans-solicitation-info.html?vue&type=template&id=4788e9c8&scoped=true&external"
import script from "./trans-solicitation-info.js?vue&type=script&lang=js&external"
export * from "./trans-solicitation-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-solicitation-info.scss?vue&type=style&index=0&id=4788e9c8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4788e9c8",
  null
  
)

export default component.exports